/**
 * flatlayBackgrounds — Presets de fond pour la génération Flat-Lay (v1.12.996).
 *
 * Le front n'envoie que l'`id` au backend (POST /flat-lay { background }).
 * Le Lambda (flat-lay-service-vertex.js) possède le mapping id → fragment de
 * prompt Gemini correspondant. Garder les `id` SYNCHRONISÉS des deux côtés.
 *
 * `swatch` = couleur d'aperçu dans le sélecteur. `id 'cream'` = défaut.
 */
export const FLATLAY_BACKGROUNDS = [
  { id: 'cream',  labelFr: 'Crème',   labelEn: 'Cream',   swatch: '#F4ECDD' },
  { id: 'white',  labelFr: 'Blanc',   labelEn: 'White',   swatch: '#FFFFFF' },
  { id: 'marble', labelFr: 'Marbre',  labelEn: 'Marble',  swatch: '#E9E9EC' },
  { id: 'wood',   labelFr: 'Bois',    labelEn: 'Wood',    swatch: '#C9A66B' },
  { id: 'blush',  labelFr: 'Rosé',    labelEn: 'Blush',   swatch: '#F3DDD9' },
  { id: 'slate',  labelFr: 'Ardoise', labelEn: 'Slate',   swatch: '#2E2E33' },
];

export const DEFAULT_FLATLAY_BG = 'cream';
export const FLATLAY_BG_STORAGE_KEY = 'flatlay_bg_preset';

export function isValidFlatLayBg(id) {
  return FLATLAY_BACKGROUNDS.some((b) => b.id === id);
}
